import React from "react";
import "../css/GeneralInformation.css";

const GeneralInformation = () => {
  const tableData = [
    {
      slNo: 1,
      information: "Name of the School",
      details: "Sahara Public Secondary School",
      isLink: false,
    },
    {
      slNo: 2,
      information: "Affiliation No.",
      details: "500430003",
      isLink: false,
    },
    {
      slNo: 3,
      information: "School Code",
      details: "10279",
      isLink: false,
    },
    {
      slNo: 4,
      information: "Complete Address with PIN Code",
      details:
        "Krishna Nagar Municipality- Ward No. 01, District: Kapilvastu ,  Lumbini, Nepal",
      isLink: false,
    },
    {
      slNo: 5,
      information: "Principal Name",
      details: "Mr. Ghufran Ahmad Shakir",
      isLink: false,
    },
    {
      slNo: 6,
      information: "Principal Qualification",
      details: "M.Sc., B.Ed., M.Ed.",
      isLink: false,
    },
    {
      slNo: 7,
      information: "School Email ID",
      details: "info@sahara.edu.np",
      isLink: true,
    },
    {
      slNo: 8,
      information: "Contact Details",
      details: "+977-984-7040404,+977-76-520102",
      isLink: false,
    },
  ];

  return (
    <section className="info-section">
      <div className="info-container">
        <h2 className="info-heading">General Information</h2>

        <div className="table-responsive">
          <table className="info-table">
            <thead>
              <tr>
                <th>SL No.</th>
                <th>INFORMATION</th>
                <th>DETAILS</th>
              </tr>
            </thead>

            <tbody>
              {tableData.map((row) => (
                <tr key={row.slNo}>
                  <td>{row.slNo}</td>

                  <td className="info-label">{row.information}</td>

                  <td className="info-details">
                    {row.isLink ? (
                      <a
                        href={`mailto:${row.details}`}
                        className="info-email-link"
                      >
                        {row.details}
                      </a>
                    ) : (
                      row.details
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default GeneralInformation;
